var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "filter-steps--container" },
    [
      _c(
        "md-field",
        { staticClass: "datepicker-container" },
        [
          _c("md-datepicker", {
            ref: "mdDatePicker",
            staticClass: "filter-steps--choices filter-step-date",
            attrs: {
              "data-testid": "service-areas-dashboard-date",
              "md-immediately": "",
              "md-debounce": 100,
              clearable: false,
            },
            model: {
              value: _vm.selectedDateFilterValue,
              callback: function ($$v) {
                _vm.selectedDateFilterValue = $$v
              },
              expression: "selectedDateFilterValue",
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }